module.exports = __webpack_public_path__ + "assets/img/51.494c8d1c.png";